import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';
import { SceneTranscodingStates } from '../../../models/scene-transcoding-states-enum';

const MUTATION = gql`
    mutation SceneTranscoding($uid: String!){
        scene_transcoding (uid: $uid) {
            transcoding_state
        }
    }
`;

export async function sceneTranscoding(uid: string): Promise<{ transcoding_state: SceneTranscodingStates }> {
    const result: FetchResult<{ scene_transcoding: { transcoding_state: SceneTranscodingStates }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.scene_transcoding;
}
